module.exports = __webpack_public_path__ + "img/serve13.7df2fa52.png";